angular.module('leanlaw').controller('ConflictClientViewCtrl', ['$scope', '$state', '$stateParams', 'userService', 'leanLawApi', 'clientManager', function ($scope, $state, $stateParams, userService, leanLawApi, clientManager) {
  clientManager.get($stateParams.id).then(client => {
    $scope.client = client;
  });
  $scope.gotoClient = function (client) {
    return $state.go('clients.client', {
      id: client.id
    });
  };
}]);